import styles from "./styles/inspectionDetails.module.css"
import { KeyDetailsContainer } from "./components/keyDetailsContainer";
import { OtherDetailsContainer } from "./components/otherDetailsContainer";
import { Skeleton } from 'antd';
import {PermissionTab} from "./components/permissionContainer";

export default function InspectionDetails (props) {
  const {isLoading, inspectionDetails, fetchInspectionDetailsByKey} = props.values;
  return (
    <>
      {
        isLoading
        ? <Skeleton /> 
        : <div>
              <div className={styles.detailsContainer}>
                <PermissionTab inspectionDetails={inspectionDetails} />
              </div>
            <div className={styles.detailsContainer}>
              <KeyDetailsContainer 
                values={{
                  inspectionDetails,
                  fetchInspectionDetailsByKey
                }}
              />  
            </div>
            <div className={styles.detailsContainer}>
              <OtherDetailsContainer 
                inspectionDetails={inspectionDetails}
              />  
            </div>
          </div>
      }
    </>
  );
}